import { SWAL2_ALERT_HELPER } from './_swalHelper';

/*
    🔥 CONFIRM — sweetalert2, VÍA TU HELPER

    No reimplemento nada: delego en SWAL2_ALERT_HELPER, que ya tiene
    resuelto el estilo, los botones sin styling nativo, reverseButtons
    y focusCancel.

    El mapeo traduce el contrato unificado a los métodos de tu helper:

      requireText  -> confirmHardDelete (escribir para habilitar)
      icon:archive -> confirmArchive
      resto        -> confirm

    Imperativo: no necesita Host.
*/

export const ConfirmSweetAlertHost = () => null;

export const onConfirmSweetAlert = ({
    tone = 'danger', icon = null, title, text, html,
    confirmText, cancelText, requireText = null, requireLabel, input = null,
}) => {

    if (input) {
        return SWAL2_ALERT_HELPER.promptCode({ title, text, input, confirmText, cancelText });
    }

    // 🔥 Eliminación con texto de confirmación
    if (requireText) {
        return SWAL2_ALERT_HELPER.confirmHardDelete({
            expectedText: requireText,
            title, text, html,
            confirmText, cancelText,
            ...(requireLabel ? { inputLabel: `${requireLabel} ` } : {}),
        });
    }

    // 🔥 Archivar
    if (icon === 'archive') {
        return SWAL2_ALERT_HELPER.confirmArchive({ title, text, html, confirmText, cancelText });
    }

    // 🔥 Confirmación común
    return SWAL2_ALERT_HELPER.confirm({ title, text, html, confirmText, cancelText });
};

/*
    🔥 Extras que SOLO tiene tu helper.
    Se exponen aparte porque no tienen equivalente en las otras
    implementaciones (mandan un código por mail, validan dos campos).
*/
export const onConfirmBulkSweetAlert = (options) => SWAL2_ALERT_HELPER.confirmBulkHardDelete(options);
